import { cn } from '~/lib/utils'

type WrapperProps = {
    className?: string
    children?: React.ReactNode
}
const Wrapper = ({ className, children }: WrapperProps) => {
    const classes = cn(
        'bg-background rounded-lg shadow-md border',
        className,
    )
    const stopPropagation = (e: React.MouseEvent) => e.stopPropagation()
    return (
        <div onClick={stopPropagation} className={classes}>
            {children}
        </div>
    )
}

export default Wrapper
